import { Howl } from "howler";
import { SoundDef, Assets } from "./asset-loader";

export function load(name: string, src: string[]): Promise<Sound> {
  return new Promise((resolve, reject) => {
    var sound = new Howl({
      src: src
    });
    sound.once("load", function() {
      resolve({
        name: name,
        sound: sound
      });
    });
  });
}

export function asset(name: string, src: string[]): SoundDef {
  return { name: name, src: src };
}

export function loadAll(
  items: SoundDef[]
): Promise<Assets<Partial<Record<string, Howl>>>> {
  var promises = items.map(item => {
    return load(item.name, item.src);
  });

  return new Promise((resolve, reject) => {
    var soundMap = {};
    Promise.all(promises).then(items => {
      items.forEach(item => {
        (soundMap as any)[item.name] = item.sound;
      });
      resolve({ type: "sound", data: soundMap });
    });
  });
}

interface Sound {
  name: string;
  sound: Howl;
}
